module.exports = __webpack_public_path__ + "static/book-mock-up-1d1bd9b81c5f3b1eac60aeff84f44cd2.png";